/* global videojs */
import vars from '../helpers';

const init = () => {
	const $videos = $('.js-video');

	$videos.each((i, el) => {
		console.log('video init');
		const $video = $(el);
		const poster = $video.attr('poster');
		const name = $video.data('name');
		const src = $video.attr('src');

		const video = videojs($video[0], {
			controls: true,
			autoplay: false,
			muted: false,
			loop: false,
			playsinline: true,
			preload: 'auto',
			responsive: true,
			poster,
			html5: {
				nativeAudioTracks: false,
				nativeVideoTracks: false,
				nativeTextTracks: false,
				vhs: {
					overrideNative: true,
				},
			},
		});

		video.src({
			src,
			type: 'application/x-mpegURL',
			withCredentials: false,
		});

		let wrapper =  $($video).parent();
		const $button = $video.closest('.popupVideo').find('.js-video-button');

		$button.on('click', (e) => {
			e.currentTarget.classList.add('is-hidden');
			video.play();
		});

		let videoInterval = false;

		$video.on('play', () => {
			vars.$html.trigger('video-play', name);

			videoInterval = setInterval(() => {
				vars.$html.trigger('video-interval-30', name);
			}, 30000);
		});

		$video.on('ended', () => {
			vars.$html.trigger('video-ended', name);
			clearInterval(videoInterval);
		});

		$video.on('pause', () => {
			clearInterval(videoInterval);
		});
	});
};

export default {
	init,
};
